import { createFeature, createReducer, on } from '@ngrx/store';
import { MetaData, Promotion } from '@emi/shared/models';
import * as promotionActions from './promotion-actions';
import * as commonActions from '../common-actions';

export interface PromotionState {
    promotions: Promotion[];
    metadata: MetaData | null;
    searchText: string | null;
    loading: boolean;
    failed: boolean;
    error: string;
}

export const promotionFeatureKey = 'promotionFilter';

const initialState: PromotionState = {
    promotions: [],
    metadata: null,
    searchText: null,
    loading: false,
    failed: false,
    error: '',
};

export const promotionFeature = createFeature({
    name: promotionFeatureKey,
    reducer: createReducer(
        initialState,
        on(promotionActions.isLoadingPromotions, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(promotionActions.getPromotionsSuccess, (state, { promotions, metadata, searchText }) => {
            return {
                ...state,
                promotions,
                metadata,
                searchText,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(promotionActions.getPromotionsFailure, (state, { error }) => {
            return {
                ...state,
                loading: false,
                failed: true,
                error: error.message,
            };
        }),
        on(promotionActions.searchPromotions, (state, { searchText }) => {
            return {
                ...state,
                loading: state.searchText !== searchText,
            };
        }),
        on(commonActions.clearFilters, () => {
            return initialState;
        })
    ),
});
